import { RecentAnswer } from "winslow-core";
import "./CollectionStatsQuestionCards.css";
import AnswerCard from "../common/AnswerCard";

export type CollectionStatsQuestionCardsProps = {
  questions: RecentAnswer[]; //questions and answers here are somewhat the same thing so it's used interchangeably - should be cleaned up
  onRatingDelete?: () => void;
};

const CollectionStatsQuestionCards = ({
  questions,
  onRatingDelete,
}: CollectionStatsQuestionCardsProps) => {
  return (
    <>
      <div className="cards-section">
        {questions.map((recentAnswer) => (
          <AnswerCard
            key={recentAnswer.id}
            recentAnswer={recentAnswer}
            onRatingDelete={onRatingDelete}
          />
        ))}
      </div>
    </>
  );
};

export default CollectionStatsQuestionCards;
